module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/folder-company.7697d3a0.svg";